import {Injectable} from '@angular/core';
import {EmailService} from '../../email/services/email.service';
import {FormShareService} from './share.service';
import {getFormTypeName} from '../form.functions';
import {contactType} from '../../project/project.constants';
import {UserContextService} from '../../user/services/user-context.service';
import {AnnualCertificationReport} from '../../incentive/compliance/models/annual-certification-report.model';
import {User} from '../../user/models/user.model';
import {UserDataService} from '../../user/services/user-data.service';
import {flatMap} from 'rxjs/operators';
import {Project} from '../../project/models/project.model';
import {FormIdentifier} from '../../project/models/form-identifier.model';
import {BalanceAdjustmentRequest} from '../../project/models/balance-adjustment-request.model';
import {EmailParameters} from '../../email/models/email-parameters.model';

@Injectable()
export class FormEmailService {
  constructor(
    private emailService: EmailService,
    private shareService: FormShareService,
    private userContext: UserContextService,
    private userDataService: UserDataService
  ) {
  }

  sendAdditionalPaymentReceivedEmail(manager: User[]) {
    const form = this.shareService.form;

    return this.emailService.sendAdditionalPaymentReceivedEmail(
      this.shareService.project,
      form.fees[0].amountPaid,
      form.type.toUpperCase(), manager
    );
  }


  sendAdditionalPaymentRequestedEmail(payeeEmail: string) {
    const form = <BalanceAdjustmentRequest>this.shareService.form;

    const payingContactIndex = this.shareService.project.projectContacts.findIndex(
      contact => contact.emailAddress === payeeEmail
    );

    const payingContactName = this.shareService.project.projectContacts[
      payingContactIndex
      ].fullName();

    const that = this;
    return this.userDataService
      .getId(payeeEmail)
      .pipe(flatMap(payeeContactId => that.emailService.sendAdditionalPaymentRequestedEmail(
        that.shareService.project,
        form.comments,
        form.adjustmentAmount,
        form.adjustmentSubtype,
        that.shareService.formId,
        payeeEmail,
        payingContactName,
        payingContactIndex,
        payeeContactId)));
  }

  sendAcrCertificationEmail(acr: AnnualCertificationReport, ccList: User[], manager: User) {
    return this.emailService.sendAcrCertificationEmail(
      acr,
      this.shareService.project,
      ccList,
      manager
    );
  }

  sendBusinessSignatoryRefusedToSignEmail() {
    return this.emailService.sendBusinessSignatoryRefusedToSignEmail(
      this.shareService.project,
      getFormTypeName(this.shareService.form.type)
    );
  }

  sendBusinessSignatureRequiredEmail(isSigneePaying: boolean) {
    const payingContactIndex = isSigneePaying
      ? this.shareService.project.projectContacts.findIndex(
        contact => contact.contactType === contactType.signee.code
      )
      : this.shareService.project.projectContacts.findIndex(
        contact =>
          contact.emailAddress.toLowerCase() === this.userContext.currentUser.emailAddress
      );

    return this.emailService.sendFormBusinessSignatureRequiredEmail(
      this.shareService.project,
      this.shareService.formId,
      this.shareService.project.businessSignatory.emailAddress,
      this.shareService.project.businessSignatory.fullName(),
      payingContactIndex
    );
  }

  sendPaymentRequiredEmail(payingContactEmail: string) {
    const payingContactIndex = this.shareService.project.projectContacts.findIndex(
      contact => contact.emailAddress === payingContactEmail
    );

    const payingContactName = this.shareService.project.projectContacts[
      payingContactIndex
      ].fullName();

    const that = this;
    return this.userDataService.getId(payingContactEmail)
      .pipe(flatMap(payingContactId => that.emailService.sendFormPaymentRequiredEmail(
        that.shareService.project,
        that.shareService.formId,
        payingContactEmail,
        payingContactName,
        payingContactIndex,
        payingContactId
      )));
  }

  sendPaymentRequiredEmailToAllNonSignees() {
    return this.emailService.sendPaymentRequiredEmailToAccountHolder(
      this.shareService.project,
      this.shareService.formId
    );
  }

  sendSubmissionSuccessfulEmail(ccList: User[]) {

    return this.emailService.sendSubmissionSuccessfulEmail(
      this.shareService.project,
      ccList,
      getFormTypeName(this.shareService.form.type),
      this.shareService.form.type,
      new Date()
    );
  }

  sendCOCExtensionRequestNotificationEmail(project: Project) {
    return this.emailService.sendCOCExtensionRequestNotificationEmail(project)
  }

  sendPrrPaymentEmail(projectId: string) {
    return this.emailService.prrPaymentEmail(projectId);
  }

  // sendECRCertificationEmail(ecr: EmployeeCertificationReport, ccList: User[]) {
  //   return this.emailService.sendECRCertificationEmail(
  //     ecr,
  //     this.shareService.project,
  //     ccList
  //   );
  // }
}
